var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.4998 73.3333C58.9093 73.3333 73.8332 58.4095 73.8332 40C73.8332 21.5905 58.9093 6.66666 40.4998 6.66666C22.0903 6.66666 7.1665 21.5905 7.1665 40C7.1665 58.4095 22.0903 73.3333 40.4998 73.3333Z",
    fill: "#5FD88E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7668 51.9333C35.1001 51.9333 34.4668 51.6667 34.0001 51.2L24.5668 41.7667C23.6001 40.8 23.6001 39.2 24.5668 38.2333C25.5335 37.2667 27.1335 37.2667 28.1001 38.2333L35.7668 45.9L52.9001 28.7667C53.8668 27.8 55.4668 27.8 56.4335 28.7667C57.4001 29.7333 57.4001 31.3333 56.4335 32.3L37.5335 51.2C37.0668 51.6667 36.4335 51.9333 35.7668 51.9333Z",
    fill: "#5FD88E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.3ac02bba6845c6a8b726a85d90d4d51c.svg";
export { ForwardRef as ReactComponent };